module.exports = __webpack_public_path__ + "static/media/confirmation_pink_icon.ed92ba1e.svg";